import preview from "../assets/preview.png";
import Cover from "../assets/Cover.png";
import briefit from "../assets/briefit.png";
import gxcover from "../assets/gxcover.png";
// import quotegen from "../assets/quotegenerator.png";

export const Data = [
  {
    id: 1,
    title: "ScholarMates",
    description:
      "Student interaction platform - Next, SocketIO, Node, Tailwind, AWS, ShadCN",
    image: preview,
    link: "https://www.scholarmates.me",
    code: "https://github.com/meghnadutta02/scholarmates",
  },
  {
    id: 2,
    title: "CritiQ",
    description: "LLM assited DeFi review reward system- MERN, Blockchain, AI",
    image: Cover,
    link: "https://critiq-one.vercel.app/",
    code: "https://github.com/ankushroy25/CritiQ",
  },
  {
    id: 3,
    title: "GenerosityX",
    description: "Social upliftment platform - MERN, GCP, OAuth, Gmail",
    image: gxcover,
    link: "https://generosityx.app/",
    code: "https://github.com/meghnadutta02/generosityX",
  },
  {
    id: 4,
    title: "BriefIt",
    description:
      "Article,Blog Summarizer application - React, Tailwind, Redux, GPT API",
    image: briefit,
    link: "https://brief-it.netlify.app/",
    code: "https://github.com/ankushroy25/Briefit",
  },
  // {
  //   id: 4,
  //   title: "DeQuote",
  //   description: "Random quote generator - HTML, CSS, JavaScript, APIs",
  //   image: quotegen,
  //   link: "https://codepen.io/ankushroy25/full/PoBLpLV",
  //   code: "https://codepen.io/ankushroy25/pen/PoBLpLV",
  // },
];
